<img
  *ngIf="user && user.verified"
  src="/assets/massimo/svg/verifiedTick.svg"
  alt="verified"
  class="w-[16px] h-[16px]"
/>
